import { Component } from "react";
import { Card, Table, Button, Row, Col, Modal, Form, Alert, Tab, Tabs } from "react-bootstrap";
import ProgramaFAQConfig from "./ProgramaFAQConfig";
import { FaPlus, FaRegEdit, FaTrash, FaCheck } from "react-icons/fa";
import api from "../../services/api";
import faqAreasService from "../../api/faq/faqAreasService";
import programaFaqService from "../../api/faq/programaFaqService";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Paginacao from '../../common/pagination';
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

class ProgramaFAQ extends Component {
    constructor(props) {
        super(props);

        this.onClickPagina = this.onClickPagina.bind(this);

        this.state = {
            listFaq: [],
            loading: true,
            loadingModal: false,
            error: '',
            page_numb: 1,
            
            // Modal
            showModal: false,
            modalTitulo: '',
            faqEditando: null,
            
            // Campos do formulário
            id: null,
            pergunta: '',
            resposta: '',
            area_id: '',
            
            // Erros de validação
            respostaError: '',
            
            // Listas auxiliares
            faqAreas: []
        };

    }

    componentDidMount() {
        this.CarregarFAQ(this.state.page_numb);
        this.carregarAreas();
    }

    carregarAreas = () => {
        faqAreasService.getAll({ ativo: true })
            .then(response => {
                this.setState({ faqAreas: response.data.results || [] });
            })
            .catch(error => {
                console.error("Erro ao carregar áreas de FAQ:", error);
            });
    }

    CarregarFAQ = (page_numb = 1) => {
        const { programaId } = this.props;

        if (!programaId) {
            this.setState({ loading: false, error: 'ID do programa não informado' });
            return;
        }

        this.setState({ loading: true, error: '' });

        api.get(`/programas/faq/?programa_id=${programaId}&page=${page_numb}`)
            .then(response => {
                this.setState({
                    listFaq: response.data,
                    loading: false,
                    error: '',
                });
            })
            .catch(error => {
                let erro_msg = 'Erro ao carregar faq do programa';

                if (error.response && error.response.status === 500) {
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                } else if (error.response && error.response.status === 403) {
                    erro_msg = 'Você não tem permissão para acessar essa área';
                }

                this.setState({
                    loading: false,
                    error: erro_msg,
                });
            });
    };

    onClickPagina(num_page) {
        this.setState({
            loading: true,
            page_numb: num_page
        });
        
        this.CarregarFAQ(num_page);
    }

    gerarResumoJson = (json, maxLength = 80) => {
        if (!json || (Array.isArray(json) && json.length === 0) || (typeof json === 'object' && Object.keys(json).length === 0)) {
            return <span className="text-muted">Vazio</span>;
        }

        try {
            let resumo = '';

            if (Array.isArray(json)) {
                const qtd = json.length;
                const preview = json.slice(0, 2).map(item => {
                    if (typeof item === 'object' && item !== null) {
                        const keys = Object.keys(item).slice(0, 3);
                        return keys.map(k => `${k}: ${this.formatarValor(item[k])}`).join(', ');
                    }
                    return String(item);
                }).join(' | ');

                resumo = `[${qtd} item${qtd > 1 ? 's' : ''}] ${preview}`;
            } else if (typeof json === 'object') {
                const keys = Object.keys(json).slice(0, 4);
                resumo = keys.map(k => `${k}: ${this.formatarValor(json[k])}`).join(', ');
            } else {
                resumo = String(json);
            }

            // Trunca se muito longo
            if (resumo.length > maxLength) {
                resumo = resumo.substring(0, maxLength) + '...';
            }

            return <span title={JSON.stringify(json, null, 2)}>{resumo}</span>;
        } catch (e) {
            return <span className="text-muted">Erro ao ler JSON</span>;
        }
    };

    formatarValor = (valor) => {
        if (valor === null || valor === undefined) return 'null';
        if (typeof valor === 'boolean') return valor ? 'true' : 'false';
        if (typeof valor === 'object') return Array.isArray(valor) ? `[${valor.length}]` : '{...}';
        if (typeof valor === 'string' && valor.length > 20) return valor.substring(0, 20) + '...';
        return String(valor);
    };

    abrirModalNovo = () => {
        this.setState({
            showModal: true,
            modalTitulo: 'Adicionar FAQ',
            faqEditando: null,
            id: null,
            pergunta: '',
            resposta: '',
            area_id: '',
            respostaError: '',
        });
    };

    abrirModalEditar = (faq) => {
        this.setState({
            showModal: true,
            modalTitulo: 'Editar FAQ',
            faqEditando: faq,
            id: faq.id,
            pergunta: faq.pergunta,
            resposta: faq.resposta,
            area_id: faq.area_id || '', // Handle legacy data or nulls
            respostaError: '',
        });
    };

    fecharModal = () => {
        this.setState({
            showModal: false,
            faqEditando: null,
            id: null,
            pergunta: '',
            resposta: '',
            area_id: '',
            respostaError: '',
        });
    };

    onChangePergunta = (e) => {
        this.setState({ pergunta: e.target.value });
    }

    onChangeArea = (e) => {
        this.setState({ area_id: e.target.value });
    }

    handleRespostaChange = (value) => {
        this.setState({ resposta: value || '', respostaError: '' });
    };

    validarFormulario = () => {
        let valido = true;

        if (!this.state.resposta || this.state.resposta.trim() === '' || this.state.resposta === '<p><br></p>') {
            this.setState({ respostaError: 'A resposta é obrigatória.' });
            valido = false;
        }

        return valido;
    };

    SalvarFaq = async () => {
        if (!this.validarFormulario()) {
            return;
        }

        const { programaId } = this.props;
        const { id} = this.state;

        this.setState({ loadingModal: true });

        const dados = {
            programa_id: programaId,
            pergunta: this.state.pergunta,
            resposta: this.state.resposta,
            area_id: this.state.area_id || null, 
        };

        try {
            if (id) {
                await programaFaqService.update(id, dados);
            } else {
                await programaFaqService.create(dados);
            }

            const MySwal = withReactContent(Swal);
            const textSwal = id ? 'FAQ atualizado com sucesso' : 'FAQ cadastrado com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            });

            this.setState({ loadingModal: false });
            this.fecharModal();
            this.CarregarFAQ(this.state.page_numb);

        } catch (error) {
            let erro_msg = 'Erro ao salvar FAQ, verifique os campos e tente novamente';

            if (error.response && error.response.status === 500) {
                erro_msg = 'Servidor indisponível no momento';
            }

            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
            });

            this.setState({ loadingModal: false });
        }
    };

    excluirFaq = (faq) => {
        const MySwal = withReactContent(Swal);

        MySwal.fire({
            title: 'Você tem certeza?',
            text: 'Esta ação não pode ser desfeita!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sim, excluir!',
            cancelButtonText: 'Cancelar'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await programaFaqService.delete(faq.id);

                    MySwal.fire(
                        'Excluído!',
                        'FAQ foi excluído com sucesso.',
                        'success'
                    );

                    this.CarregarFAQ(this.state.page_numb);

                } catch (error) {
                    let erro_msg = 'Erro ao excluir FAQ';
                    if (error.response && error.response.status === 500) {
                        erro_msg = 'Servidor indisponível no momento';
                    }
                    MySwal.fire({
                        icon: 'error',
                        title: 'Erro',
                        text: erro_msg,
                    });
                }
            }
        });
    };

    renderRows = () => {
        if ('results' in this.state.listFaq && this.state.listFaq.results.length > 0) {
            return this.state.listFaq.results.map((faq) => (
                <tr key={faq.id}>
                    <td>{faq.id}</td>
                    <td>
                        {faq.pergunta}
                        {faq.dados_area && (
                            <div className="text-muted small">
                                <span className="fw-bold">Área:</span> {faq.dados_area.nome}
                            </div>
                        )}
                    </td>
                    <td style={{ maxWidth: '300px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        <span dangerouslySetInnerHTML={{ __html: faq.resposta || '' }} />
                    </td>
                    <td className="text-end">
                        <Button variant="light" size="sm"  className="me-1" onClick={() => this.abrirModalEditar(faq)}>
                            <FaRegEdit /> Editar
                        </Button>
                        <Button variant="danger" size="sm" onClick={() => this.excluirFaq(faq)}>
                            <FaTrash /> Excluir
                        </Button>
                    </td>
                </tr>
            ));
        }

        return (
            <tr>
                <td colSpan={5}>Nenhum faq cadastrado para este programa</td>
            </tr>
        );
    };

    render() {
        const { 
            loading, 
            loadingModal,
            error, 
            showModal, 
            modalTitulo,
            respostaError,
            listFaq,
            page_numb,
        } = this.state;

        return (
            <>
                <Tabs defaultActiveKey="perguntas" id="faq-tabs" className="mb-3 aditus-tabs">
                    <Tab eventKey="perguntas" title="Perguntas e Respostas">
                        <Card className="cardDestaque">
                            <Card.Body>
                                <Row className="align-items-center mb-3">
                                    <Col sm={6} lg={6}>
                                        <h4>FAQ do Programa</h4>
                                    </Col>
                                    <Col sm={6} lg={6} className="text-end">
                                        <Button variant="secondary" size="sm" onClick={this.abrirModalNovo}>
                                            <FaPlus /> Adicionar FAQ
                                        </Button>
                                    </Col>
                                </Row>

                                <Table responsive className="custom-table">
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Pergunta</th>
                                            <th>Resposta</th>
                                            <th className="text-end"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <tr>
                                                <td colSpan={5}>Carregando...</td>
                                            </tr>
                                        ) : (
                                            error ? (
                                                <tr>
                                                    <td colSpan={5}>{error}</td>
                                                </tr>
                                            ) : this.renderRows()
                                        )}
                                    </tbody>
                                </Table>

                                {'results' in listFaq && listFaq.results.length > 0 && 
                                    <Paginacao  dados={listFaq}  loading={loading} page_numb={page_numb}  _onClickPagina={this.onClickPagina} />
                                }
                            </Card.Body>
                        </Card>
                    </Tab>
                    <Tab eventKey="configuracoes" title="Configuração de Transbordo">
                        <ProgramaFAQConfig programaId={this.props.programaId} />
                    </Tab>
                </Tabs>

                {/* Modal de Cadastro/Edição */}
                <Modal show={showModal} onHide={this.fecharModal} size="xl" backdrop="static">
                    <Modal.Header closeButton>
                        <Modal.Title>{modalTitulo}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Row>
                                <Col sm={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Pergunta</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="pergunta"
                                            value={this.state.pergunta}
                                            onChange={this.onChangePergunta}
                                            placeholder="Pergunta"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col sm={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Área</Form.Label>
                                        <Form.Control
                                            as="select"
                                            name="area_id"
                                            value={this.state.area_id}
                                            onChange={this.onChangeArea}
                                        >
                                            <option value="">Selecione uma área (Opcional)</option>
                                            {this.state.faqAreas.map(area => (
                                                <option key={area.id} value={area.id}>
                                                    {area.nome}
                                                </option>
                                            ))}
                                        </Form.Control>
                                    </Form.Group>
                                </Col>

                                <Form.Group className="mb-3">
                                    <Form.Label>Resposta</Form.Label>

                                    {respostaError && (
                                        <Alert variant="danger" className="py-1 mb-2">{respostaError}</Alert>
                                    )}

                                    <ReactQuill
                                        theme="snow"
                                        value={this.state.resposta}
                                        onChange={this.handleRespostaChange}
                                        placeholder="Digite a resposta..."
                                    />
                                </Form.Group>
                            </Row>  
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.fecharModal}>
                            Cancelar
                        </Button>
                        <Button  variant="success"  onClick={this.SalvarFaq} disabled={loadingModal}>
                            {loadingModal ? (
                                <span className="spinner-border spinner-border-sm"></span>
                            ) : (
                                <>
                                    <FaCheck className="me-1" /> Salvar
                                </>
                            )}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

export default ProgramaFAQ;
